export default __webpack_public_path__ + "./images/congrats.3a9fdc07.svg";